/*
 * @Description:拦截器
 * @Author: kai.zhou
 * @Date: 2020-03-24 17:33:22
 * @LastEditors: Mayer
 * @LastEditTime: 2023-08-16 15:10:00
 */
import axios from "axios";
import { API_BASE_URL } from "./env";
//封装loading
import { Toast } from "antd-mobile";

function startLoading() {
  Toast.loading("Loading...", 10, () => { });
}

function endLoading() {
  Toast.hide();
}
let needLoadingRequestCount = 0;

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
// 对所有 axios 请求做处理
//axios.defaults.withCredentials = true;
const Service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: false, // 是否允许带cookie这些
  responseType: "json",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
});

//请求前拦截
Service.interceptors.request.use(
  (config) => {
    //开始loading
    showFullScreenLoading();
    return config;
  },
  (error) => {
    console.log("request error", error);
    return Promise.reject(error);
  }
);
// 返回后拦截
Service.interceptors.response.use(
  (response) => {
    //结束loading
    tryHideFullScreenLoading();
    //批量处理
    return response;
  },
  (error) => {
    //结束loading
    tryHideFullScreenLoading();
    // if (401 === error.response.status) {
    //   console.log("状态码400");
    // } else {
    //   console.log("error", error);
    return Promise.reject(error);
    // }
  }
);

export default Service;
